export const data = [
  {
    id: 1,
    title: 'Mackolik Analytics Verileri',
    titleEN: 'Mackolik Analytics Data',
    image: 'https://srv-cdn.onedio.com/store/1971978d129a141be8044f41b57b96a776b60bfd1f067adf8509c91f02655e5c.png',
    imageEN: 'https://srv-cdn.onedio.com/store/c8b80ce8b7822951f9eda30aea13f73c5cecffd40a4afc06945eb637db000297.png',
    active: true
  },
  {
    id: 2,
    title: 'Cinsiyet',
    titleEN: 'Gender',
    image: 'https://srv-cdn.onedio.com/store/8f6e4f2a5888ddb6957a4ff5aea0b85b78a08b34c03b8b40cfd65fbe5c51b6f8.png',
    imageEN: 'https://srv-cdn.onedio.com/store/8f6e4f2a5888ddb6957a4ff5aea0b85b78a08b34c03b8b40cfd65fbe5c51b6f8.png',
    active: false
  },
  {
    id: 3,
    title: 'Yaş Kırılımı',
    titleEN: 'Age Distribution',
    image: 'https://srv-cdn.onedio.com/store/ae0d0ad38d0fe333dc2ea48739a51cf954199b7683581b3c79b5966214770a74.png',
    imageEN: 'https://srv-cdn.onedio.com/store/ae0d0ad38d0fe333dc2ea48739a51cf954199b7683581b3c79b5966214770a74.png',
    active: false
  },
  {
    id: 4,
    title: 'Sosyal Medya',
    titleEN: 'Social Media',
    image: 'https://srv-cdn.onedio.com/store/109b0c26fe4d5af2e87b7a123a7d48af3c1402d6d4a8243f1531c90a7d800e90.png',
    imageEN: 'https://srv-cdn.onedio.com/store/fb3bfe2e8dc33db7e4884c8bc409ea6785ca8cc061b2a6db52a6e79a2a3107ba.png',
    active: false
  }
]
